/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../types/schema.generated';

import gql from 'graphql-tag';
import { AppFooterFragmentDoc } from '../components/organisms/AppFooter/AppFooter.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type TermType =
  /** プライバシーポリシー */
  | 'PRIVACY_POLICY'
  /** 通信の秘密 */
  | 'SECRECY_OF_COMMUNICATIONS'
  /** 利用規約 */
  | 'TERMS_OF_SERVICE';

export type FetchGuestLayoutQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchGuestLayoutQuery = { terms: Array<{ type: Types.TermType, title: string }> };


export const FetchGuestLayoutDocument = gql`
    query FetchGuestLayout {
  ...AppFooter
}
    ${AppFooterFragmentDoc}`;

/**
 * __useFetchGuestLayoutQuery__
 *
 * To run a query within a Vue component, call `useFetchGuestLayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchGuestLayoutQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchGuestLayoutQuery();
 */
export function useFetchGuestLayoutQuery(options: VueApolloComposable.UseQueryOptions<FetchGuestLayoutQuery, FetchGuestLayoutQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchGuestLayoutQuery, FetchGuestLayoutQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchGuestLayoutQuery, FetchGuestLayoutQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchGuestLayoutQuery, FetchGuestLayoutQueryVariables>(FetchGuestLayoutDocument, {}, options);
}
export function useFetchGuestLayoutLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchGuestLayoutQuery, FetchGuestLayoutQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchGuestLayoutQuery, FetchGuestLayoutQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchGuestLayoutQuery, FetchGuestLayoutQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchGuestLayoutQuery, FetchGuestLayoutQueryVariables>(FetchGuestLayoutDocument, {}, options);
}
export type FetchGuestLayoutQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchGuestLayoutQuery, FetchGuestLayoutQueryVariables>;